import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';

import { UserService } from '../services/user.service';
import { User } from '../models/user';

@Component({
    selector: 'max-footer',
    templateUrl:'./footer.component.html',
    styleUrls: ['./footer.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

    user$: Observable<User>;
    constructor(private userService: UserService) {}

    ngOnInit(): void {
     this.user$ = this.userService.getUser();

    }

}